import { render, staticRenderFns } from "./kortrijk.vue?vue&type=template&id=8ac29158"
import script from "./kortrijk.vue?vue&type=script&lang=js"
export * from "./kortrijk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports